import { render, staticRenderFns } from "./rebateDatail.vue?vue&type=template&id=3ffa60c9&scoped=true&"
import script from "./rebateDatail.vue?vue&type=script&lang=js&"
export * from "./rebateDatail.vue?vue&type=script&lang=js&"
import style0 from "./rebateDatail.vue?vue&type=style&index=0&id=3ffa60c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa60c9",
  null
  
)

export default component.exports